export class ValidateProcedureSigtapRequest {
    public dateCompetence: string;

    public procedureSigtap: string[];

    public procedureSigtapCBO: string[];
}